

export function computeNextProductState(feedPage, productIndex, feedPageIndex, step = 1) {
  const nextProduct = productIndex + step;
  const nextPage = parseInt(nextProduct / feedPage.page_size, 10);
  if (nextProduct >= feedPage.total_products) {
    return { feedPageIndex: 0, productIndex: 0, reloadingProducts: true };
  }
  if (nextPage > feedPageIndex) {
    return {
      feedPageIndex: nextPage,
      productIndex: nextProduct,
      reloadingProducts: true,
    };
  }
  return { productIndex: nextProduct };
}

export function computePrevProductState(feedPage, productIndex, feedPageIndex, step = 1) {
  const prevProduct = productIndex - step;
  const prevPage = parseInt(prevProduct / feedPage.page_size, 10);
  if (prevProduct < 0) {
    return {
      feedPageIndex: feedPage.max_pages,
      productIndex: feedPage.total_products - 1,
      reloadingProducts: true,
    };
  }
  if (prevPage < feedPageIndex) {
    return {
      feedPageIndex: prevPage,
      productIndex: prevProduct,
      reloadingProducts: true,
    };
  }
  return { productIndex: prevProduct };
}

export function computeSelectProductIndex(index) {
  return { productIndex: index };
}

export function computeFeedPageIndex(page) {
  return { feedPageIndex: page };
}
